import { isAnalyticsAllowed } from "@/components/cookie-consent/consent";
import { Network } from "./network";

export const createMixpanel = () => {
  document.addEventListener(
    "click",
    async (event) => {
      const target = getEventTarget(event);

      if (target !== undefined) {
        await sendMixpanelEvent(target.dataset);
      }
    },
    {
      capture: true,
    },
  );
};

const getEventTarget = (event: PointerEvent) => {
  if (event.target instanceof Element) {
    const target = event.target.closest("[data-event-source]");

    if (target instanceof HTMLElement) {
      return target;
    }
  }

  return undefined;
};

type MixpanelEventProps = {
  "data-event-section": string;
  "data-event-source": string;
  [key: `data-event-${string}`]: string;
};

export const mixpanelEvent = async (data: MixpanelEventProps) => {
  const div = document.createElement("div");

  for (const [key, value] of Object.entries(data)) {
    div.setAttribute(key, value);
  }

  await sendMixpanelEvent(div.dataset);
};

const sendMixpanelEvent = async (dataset: DOMStringMap) => {
  if (!isAnalyticsAllowed()) {
    return;
  }

  await Network.post("/api/v1/c/", dataset);
};
